<p>client-pdfscheduler works!</p>
